"use client";

import React, { useRef, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowLeft } from "lucide-react";
export default function FromIdeaToShelf() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  const bookContainerRef = useRef<HTMLDivElement>(null);
  const [tilt, setTilt] = useState({
    x: 0,
    y: 0
  });
  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!bookContainerRef.current) return;
    const rect = bookContainerRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const centerX = rect.width / 2;
    const centerY = rect.height / 2;
    const maxTilt = 12;
    const tiltX = (centerY - y) / centerY * maxTilt;
    const tiltY = (x - centerX) / centerX * maxTilt;
    setTilt({
      x: tiltX,
      y: tiltY
    });
  };
  const handleMouseLeave = () => {
    setTilt({
      x: 0,
      y: 0
    });
  };
  return <section data-section-id="228384" id="it-built-for-the-startup-pace" className="bg-background text-foreground relative min-h-[90vh] flex items-center overflow-hidden py-24">
      {}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1639306/img/grid_pattern_bg.png)] bg-cover bg-center mix-blend-screen" aria-hidden="true" />

      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/5 rounded-full blur-[120px] pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          
          {}
          <div ref={textRef} className={`transition-all duration-[1200ms] ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-16"}`}>
            <h1 className="text-5xl md:text-6xl lg:text-8xl font-default font-bold leading-[1.1] tracking-tighter mb-8 bg-clip-text text-transparent bg-gradient-to-br from-foreground to-primary">
              IT Built for the,
              <br />
              <span className="text-inherit">Startup Pace.</span>
            </h1>
            
            <p className="text-lg md:text-xl font-default text-muted-foreground mb-10 max-w-xl leading-relaxed">
              Precision fractional IT management for high-growth startups. Flat $110/device pricing includes enterprise-grade RMM, end-user support, and O365 management with zero markups.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild size="lg" className="h-14 px-8 text-lg rounded-none shadow-lg bg-primary text-primary-foreground hover:opacity-90">
                <Link to="#">
                  Get Started
                  <ArrowLeft className="mr-2 h-5 w-5" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="h-14 px-8 text-lg rounded-none border-border hover:bg-white/5 text-foreground">
                <Link to="#">The Partnership</Link>
              </Button>
            </div>
          </div>

          {}
          <div className="relative w-full max-w-[450px] mx-auto aspect-[3/4] perspective-[1200px] cursor-pointer group" ref={bookContainerRef} onMouseMove={handleMouseMove} onMouseLeave={handleMouseLeave}>
            <div className="w-full h-full transition-transform duration-300 ease-out preserve-3d relative" style={{
            transform: `rotateX(${tilt.x}deg) rotateY(${tilt.y}deg)`,
            transformStyle: "preserve-3d"
          }}>
              {}
              <div className="absolute -inset-4 bg-primary/20 blur-2xl rounded-xl -z-10 transform translate-y-8 transition-opacity duration-300 group-hover:opacity-70" />
              
              {}
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1639306/img/laptop_3d_glass.png" alt="Fractional IT Infrastructure Visualization" className="w-full h-full object-cover shadow-2xl rounded-r-md rounded-l-sm border-l-4 border-l-white/10 backdrop-blur-md" style={{
              backfaceVisibility: "hidden"
            }} />
              
              {}
              <div className="absolute top-0 right-0 h-full w-[20px] bg-gradient-to-r from-primary/20 to-primary/5 origin-right transform rotateY-90 rounded-r-sm" style={{
              transform: "rotateY(90deg) translateZ(1px)",
              right: "-20px"
            }} />
            </div>
          </div>
          
        </div>
      </div>
    </section>;
}